export default "__VITE_ASSET__Bik5kQw1__"